<div class="wrapper">
  <app-page-info
    [resourceName]="releaseCalendarResourceType.name"
    [loginAndRoles]="loginAndRoles"
  />
  <div
    class="header-info"
    app-release-calendar-page-info
    [(releaseCalendarData)]="releaseCalendarData"
    [(releaseCalendarSelectedOptions)]="releaseCalendarSelectedOptions"
    [(visibleGroups)]="visibleGroups"
    [(currentZoomOption)]="currentZoomOption"
  ></div>
  @if (isLoading()) {
    <app-loader/>
  }
  @if (releaseCalendarData()) {
    <div
      class="groups"
      [style]="groupStyles()"
    >
      @for (product of releaseCalendarData()?.products; track product.id; ; let productIndex = $index) {
        <div
          class="container"
          [class.container-visible]="visibleGroups()[productIndex]"
        >
          <button
            mat-stroked-button
            color="primary"
            class="toggle-btn"
            [class.visible]="!visibleGroups()[productIndex]"
            (click)="toggleGroupVisibility(productIndex)"
          >
            {{ !visibleGroups()[productIndex] ? product.name : '-' }}
          </button>
          @if (isNoVisibleGroup()) {
            <div class="arrow-container">
              @for (arrowBtn of arrowButtons; track arrowBtn.iconName) {
                <button
                  mat-mini-fab
                  class="arrow-btn"
                  (click)="handleArrowClick(productIndex, arrowBtn.direction)"
                >
                  <i [class]="arrowBtn.iconName"></i>
                </button>
              }
            </div>
          }
          @if (visibleGroups()[productIndex] && releaseCalendarSelectedOptions() !== null) {
            <div
              class="group"
              @smoothShowHideHeight
            >
              <app-release-calendar-product
                [releaseCalendarProduct]="product"
                [hidden]="visibleGroups()[productIndex]"
              />
              <app-release-calendar-product-expenses
                [productExpenses]="product.productExpenses"
                [releaseCalendarSelectedOptions]="releaseCalendarSelectedOptions()!"
                [productExpensesParams]="{
                  plannedDayPrice: product.plannedDayPrice,
                  plannedMonthPrice: product.plannedMonthPrice,
                  productName: product.name
                }"
                [productId]="product.id"
                [planFactExceptions]="product.planFactExceptions"
                [loginAndRoles]="loginAndRoles!"
              />
              @if (product.teams.length) {
                <div class="teams">
                  @for (team of product.teams; track $index) {
                    @if (team.managers.length) {
                      <app-release-calendar-team
                        class="teams-item"
                        [team]="team"
                        [releaseCalendarSelectedOptions]="releaseCalendarSelectedOptions()!"
                      />
                    }
                  }
                </div>
              } @else {
                <div class="managers-empty">
                  Нет менеджеров
                </div>
              }
            </div>
          }
        </div>
      } @empty {
        <div>
          test
        </div>
      }
    </div>
  }
</div>
